import { ROW_STATUS } from '../constants/reviewFilters.js';

// A cell that starts like a formula would run when the file is opened in a spreadsheet.
const defuse = (cell) => (/^[=+\-@\t\r]/.test(cell) ? `'${cell}` : cell);
const quote = (raw) => {
  const cell = defuse(raw);
  return /[",\n\r]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell;
};

/**
 * CSV with only the rows in error: the file row number, every original column, and the
 * problems found. Built client-side, no network.
 *
 * @param {object[]} rows Review rows.
 * @param {string[]} headers Column names of the original file.
 * @param {(issue: object) => string} describeIssue Translated text of an issue.
 * @param {[string, string]} extraHeaders Names of the leading row-number and trailing problems columns.
 */
export function buildErrorsCsv(rows, headers, describeIssue, [rowHeader, problemsHeader]) {
  const lines = [
    [rowHeader, ...headers, problemsHeader],
    ...rows
      .filter((row) => row.status === ROW_STATUS.ERROR)
      .map((row) => [
        String(row.rowNumber),
        ...headers.map((_, column) => row.cells[column] ?? ''),
        row.issues.map(describeIssue).join(' | '),
      ]),
  ];
  return `${lines.map((cells) => cells.map(quote).join(',')).join('\r\n')}\r\n`;
}
